<template>
  <div v-if="createdBy" class="row mt-3">
    <div class="col text-start text-body-secondary">تم إضافة هذا العقار بواسطة: {{ createdBy }}</div>
  </div>
  <div v-if="dataRow && dataRow.deletedAt" class="row mt-3">
    <div class="col">
      <div class="alert alert-warning">هذا العقار تم حذفه بواسطة العميل بتاريخ {{ $shortDate(dataRow.deletedAt) }}</div>
    </div>
  </div>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <mainLoader v-if="mainLoading" />
    <!--begin::Body-->
    <div class="card-body">
      <ExchangePaymentDetails :dataRow="dataRow" />
      <div class="row steps-container">
        <div class="col" v-for="(title, index) in stepTitles" :key="index">
          <div class="steps" @click="jumbToStep(index + 1)">
            <span :class="{ active: step === index + 1 }">
              {{ title }}
            </span>
          </div>
        </div>
      </div>
      <!-- owner type -->
      <div v-if="step == 1">
        <div class="mb-3">
          <div class="row">
            <div class="col-12 col-sm-6">
              <label class="form-label" for="">العميل: <span class="req">*</span></label>
              <div>{{ userMobile }}</div>
            </div>
            <div class="col-12 col-sm-6">
              <loader v-if="userLoader" />
              <div v-if="userName">
                <label class="form-label" for="">اسم العميل:</label>
                <div>{{ userName }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-12 col-sm-6">
              <label class="form-label" for="">الاسم: <span class="req">*</span></label>
              <div>{{ name }}</div>
            </div>
            <div class="col-12 col-sm-6">
              <label class="form-label" for="">الجوال: <span class="req">*</span></label>
              <div>{{ mobile }}</div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-12 col-sm-6">
              <label class="form-label" for="">البريد الإلكتروني:</label>
              <div>{{ email }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- property data -->
      <div v-if="step == 2">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">نوع النشاط التجاري: <span class="req">*</span></label>
            <div>{{ (dataRow.ExchangeBusiness)? dataRow.ExchangeBusiness.name : 'غير معروف' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">مساحة المشروع:</label>
            <div>{{ area }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">وصف مختصر للمشروع: <span class="req">*</span></label>
            <div>{{ description }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">قيمة الإيجار السنوي:</label>
            <div>{{ rentPrice }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">مدة عقد الإيجار المتبقة: <span class="req">*</span></label>
            <div>{{ (dataRow.Age)? dataRow.Age.name : 'غير معروف' }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">عدد العمالة:</label>
            <div>{{ workersCount }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">سبب التقبيل: <span class="req">*</span></label>
            <div>{{ (dataRow.ExchangeReason)? dataRow.ExchangeReason.name : 'غير معروف' }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">المنطقة: <span class="req">*</span></label>
            <div>{{ (dataRow.Region)? dataRow.Region.name : 'غير معروف' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">المدينة: <span class="req">*</span></label>
            <div>{{ (dataRow.City)? dataRow.City.name : 'غير معروف' }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الحي: <span class="req">*</span></label>
            <div>{{ (dataRow.Neighborhood)? dataRow.Neighborhood.name : 'غير معروف' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الموقع على الخريطة:</label>
            <div ref="myMap" style="width: 100%; height: 350px;"></div>
            <div class="row pt-2">
              <div class="col">
                <label for="" class="form-label">خط العرض - latitude</label>
                <div>{{ latitude }}</div>
              </div>
              <div class="col">
                <label for="" class="form-label">خط الطول - longitude</label>
                <div>{{ longitude }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الواجهة: <span class="req">*</span></label>
            <div>{{ (dataRow.ExchangeFront)? dataRow.ExchangeFront.name : 'غير معروف' }}</div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الاصول والموجودات:</label>
            <div>{{ assetsList }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">حالة الاصول: <span class="req">*</span></label>
            <div>{{ (dataRow.ExchangeAsset)? dataRow.ExchangeAsset.name : 'غير معروف' }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">هل هناك إلتزامات مالية أو ديون؟</label>
            <div>{{ (dataRow.hasDebts)? 'نعم' : 'لا' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">وضح التفاصيل:</label>
            <div>{{ debtsList }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label for="" class="form-label">نقاط قوة المشروع:</label>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-auto mb-3" v-for="row in dataRow.ExchangeStrengths" :key="row.id">
                <div>{{ row.name }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label for="" class="form-label">نقاط ضعف المشروع:</label>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-auto mb-3" v-for="row in dataRow.ExchangeWeaknesses" :key="row.id">
                <div>- {{ row.name }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">عمر المشروع:</label>
            <div>{{ (dataRow.Age)? dataRow.Age.name : 'غير معروف' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">عدد المكاتب:</label>
            <div>{{ officesCount }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">عدد الغرف:</label>
            <div>{{ roomsCount }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">عدد الصالات:</label>
            <div>{{ hallsCount }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">عدد الفتحات:</label>
            <div>{{ doorsCount }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">عدد دورات المياة:</label>
            <div>{{ bathroomsCount }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">عدد الطوابق (الادوار):</label>
            <div>{{ floorsCount }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">عدد مواقف السيارت:</label>
            <div>{{ parkingCount }}</div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">المبلغ المطلوب:</label>
            <div>{{ price }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">ملاحظات اخرى:</label>
            <div>{{ notices }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">حالة الإعلان: </label>
            <div>{{ statusChoices[status] }}</div>
          </div>
        </div>

      </div>
      <!-- images -->
      <div v-if="step == 3">
        <div class="row">
          <div class="col-12 col-sm-3 media-img-container" v-for="(img, indx) in mediaList" :key="indx">
            <img :src="MEDIA_URL+img.path" class="img-thumbnail img-fluid" alt="">
          </div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast, shortDate } from '@/helpers/tools';
import ExchangePaymentDetails from './paymentDetails.vue';

export default {
  name: 'ExchangesView',
  components: {ExchangePaymentDetails},
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    statusChoices: {
      type: Object,
      default: {},
    },
  },
  data(){
    return {
      mainLoading: false,
      userLoader: false,
      mediaLoader: false,
      formLoader: false,
      rentalLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      step: 1,
      stepTitles: ["المالك", "بيانات التقبيل", "الصور"],
      // for config
      userMobile: null,
      userName: null,
      uploadedReceipt: null,
      citiesList: [],
      neighborhoodsList: [],
      mediaList: [],
      createdBy: null,
      // fields
      userId: null,
      name: '',
      mobile: '',
      email: '',
      businessId: null,
      area: null,
      description: '',
      rentPrice: null,
      ageId: null,
      workersCount: null,
      reasonId: null,
      regionId: null,
      cityId: null,
      neighborhoodId: null,
      latitude: 24.7136,
      longitude: 46.6753,
      frontId: null,
      assetsList: '',
      assetId: null,
      hasDebts: false,
      debtsList: '',
      projectAgeId: null,
      officesCount: null,
      roomsCount: null,
      hallsCount: null,
      doorsCount: null,
      bathroomsCount: null,
      floorsCount: null,
      parkingCount: null,
      price: null,
      notices: '',
      status: null,
      mediaIds: [],
      weaknesses: [],
      strengths: [],
      map: null,
      marker: null,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GOOGLE_MAP_API'])
  },
  methods: {
    prevStep(){
      this.step = this.step - 1;
      if(this.step == 2){
        this.initialGoogleMap();
      }
    },
    nextStep(){
      this.hasError = false;
      this.errorNumber = 0;
      this.step = this.step + 1;
      if(this.step == 2){
        this.initialGoogleMap();
      }
    },
    // google map 
    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }

      // Initialize Map
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { lat: this.latitude ?? 24.7136, lng: this.longitude ?? 46.6753 },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { lat: this.latitude ?? 24.7136, lng: this.longitude ?? 46.6753 },
        map: this.map,
        draggable: false, // Allow dragging the marker
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.GOOGLE_MAP_API}&loading=async&libraries=places&callback=initMap`;
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    jumbToStep(stepNum){
      if(this.dataRow){
        this.step = stepNum;
        if(stepNum == 2){
          this.initialGoogleMap();
        }
      }
    },
  },
  created(){
    if(this.dataRow){
      // for config
      if(this.dataRow.ExchangeMedia){
        this.dataRow.ExchangeMedia.map(m => {
          this.mediaList.push({
            id: m.id,
            path: m.filePath,
          });
          this.mediaIds.push(m.id);
        });
      }
      this.userMobile = this.dataRow.User.mobile;
      this.userName = this.dataRow.User.name;
      this.userId = this.dataRow.userId;
      this.name = this.dataRow.name;
      this.mobile = this.dataRow.mobile;
      this.email = this.dataRow.email;
      this.businessId = this.dataRow.businessId;
      this.area = this.dataRow.area;
      this.description = this.dataRow.description;
      this.rentPrice = this.dataRow.rentPrice;
      this.ageId = this.dataRow.ageId;
      this.workersCount = this.dataRow.workersCount;
      this.reasonId = this.dataRow.reasonId;
      this.regionId = this.dataRow.regionId;
      this.cityId = this.dataRow.cityId;
      this.neighborhoodId = this.dataRow.neighborhoodId;
      this.latitude = (this.dataRow.latitude)? parseFloat(this.dataRow.latitude) : null;
      this.longitude = (this.dataRow.longitude)? parseFloat(this.dataRow.longitude) : null;
      this.frontId = this.dataRow.frontId;
      this.assetsList = this.dataRow.assetsList;
      this.assetId = this.dataRow.assetId;
      this.hasDebts = this.dataRow.hasDebts;
      this.debtsList = this.dataRow.debtsList;
      this.projectAgeId = this.dataRow.projectAgeId;
      this.officesCount = this.dataRow.officesCount;
      this.roomsCount = this.dataRow.roomsCount;
      this.hallsCount = this.dataRow.hallsCount;
      this.doorsCount = this.dataRow.doorsCount;
      this.bathroomsCount = this.dataRow.bathroomsCount;
      this.floorsCount = this.dataRow.floorsCount;
      this.parkingCount = this.dataRow.parkingCount;
      this.price = this.dataRow.price;
      this.notices = this.dataRow.notices;
      this.status = this.dataRow.status;
      if(this.dataRow.ExchangeStrengths){
        this.dataRow.ExchangeStrengths.map(f => {
          this.strengths.push(f.id);
        })
      }
      if(this.dataRow.ExchangeWeaknesses){
        this.dataRow.ExchangeWeaknesses.map(f => {
          this.weaknesses.push(f.id);
        })
      }
    }
  }
}
</script>

<style scoped>
.steps-container {
  margin-bottom: 40px;
}
.steps {
  display: flex;
  justify-content: space-around;
  white-space: nowrap;
  font-weight: bold;
  cursor: pointer;
}

.steps span {
  padding: 5px 15px;
  border-bottom: 3px solid #ccc;
}

.steps .active {
  color: #007bff;
  border-bottom: 3px solid #007bff;
}
</style>
